module.exports = __webpack_public_path__ + "img/icon_success_payment@2x.218dfc5a.png";